import * as React from "react";
import {
    service,
    models,
    Embed,
    IEmbedConfiguration,
    Report
} from "powerbi-client";
import logo from "../../assets/logos/logo.png";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
declare var powerbi: service.Service;

export interface IProps extends IEmbedConfiguration {
    id: string;
    accessToken: string;
    embedUrl: string;
    pageName?: string;
    filters?: models.IFilter[];
    showFilterMenu?: boolean;
    navContentPaneEnabled?: boolean;
    className?: string;
    isMobileView: boolean;
}

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        root: {
            height: "650px",
            maxWidth: "1155px",
            margin: "auto",
            backgroundColor: "#FFFFF",
            position: "relative",
            "&::before": {
                backgroundImage: `url(${logo})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                position: "absolute",
                display: "inline-block",
                width: "100%",
                height: "100%",
                zIndex: -1,
                opacity: 1,
                content: "no-close-quote",
                animation: `$myEffect 1250ms infinite`
            }
        },
        "@keyframes myEffect": {
            "0%": {
                opacity: 0.25
            },
            "10%": {
                opacity: 0.5
            },
            "20%": {
                opacity: 0.75
            },
            "30%": {
                opacity: 0.8
            },
            "40%": {
                opacity: 0.9
            },
            "50%": {
                opacity: 1
            },
            "60%": {
                opacity: 0.9
            },
            "70%": {
                opacity: 0.8
            },
            "80%": {
                opacity: 0.75
            },
            "90%": {
                opacity: 0.5
            },
            "100%": {
                opacity: 0.25
            }
        }
    })
);

export const Branding = props => {
    const classes = useStyles(); // how to assign UseStyle

    return <div className={classes.root}> {props.children}</div>;
};

export class PowerBiEmbeddedReport extends React.Component<IProps, any> {
    component: Embed | null;
    //@ts-ignore
    rootElement: HTMLElement;

    constructor(props: IProps) {
        super(props);
        this.component = null;
        this.state = {
            firstRender: true,
            tokenType: models.TokenType.Embed,
            type: "report",
            settings: {
                filterPaneEnabled: this.props.showFilterMenu,
                navContentPaneEnabled: this.props.navContentPaneEnabled,
                layoutType: this.props.isMobileView
                    ? models.LayoutType.MobilePortrait
                    : models.LayoutType.Master
            }
        };
    }

    public async getBookmark(): Promise<string | undefined> {
        const report = this.component as Report;

        if (report) {
            const bookmark = await report.bookmarksManager.capture();

            return bookmark.state;
        }
    }

    public async setBookmark(bookmark: string): Promise<void> {
        const report = this.component as Report;

        if (report) {
            await report.bookmarksManager.applyState(bookmark);
        }
    }

    componentDidMount() {
        this.updateState(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        this.updateState(nextProps);
    }

    componentDidUpdate() {
        if (this.validateConfig(this.state)) {
            this.embed(this.state);
        }
    }

    componentWillUnmount() {
        this.reset();
    }

    async onLoaded() {
        console.log("LOADED");
    }

    embed(config: IEmbedConfiguration): Embed {
        this.reset();
        this.component = powerbi.embed(this.rootElement, config);
        this.component.on("rendered", () => {
            if (this.component) {
                this.component.iframe.style.visibility = "visible";
            }
        });

        this.component.on("loaded", async () => {
            await this.onLoaded();
        });

        this.component.iframe.style.visibility = "hidden";
        this.component.iframe.frameBorder = "none";
        return this.component;
    }

    reset() {
        powerbi.reset(this.rootElement);
        this.component = null;
    }

    resetView() {
        const report = this.component as Report;

        if (report) {
            report.reload();
        }
    }

    shouldComponentUpdate(nextProps: IProps, _nextState: any) {
        if (
            !this.state.firstRender &&
            this.props.isMobileView === nextProps.isMobileView
        ) {
            return false;
        } else {
            return true;
        }
    }

    updateState(props: IProps) {
        const nextState = assign({}, this.state, props, {
            firstRender: false,
            settings: {
                filterPaneEnabled: props.showFilterMenu,
                navContentPaneEnabled: props.navContentPaneEnabled,
                layoutType: props.isMobileView
                    ? models.LayoutType.MobilePortrait
                    : models.LayoutType.Master
            }
        });
        /**
         * This property must be removed from the state object so that it doesn't get used in the embedConfig.
         * This would be passed to `powerbi.embed(element, embedConfig)` and attempted to be sent over postMessage;
         * however, functions cannot be cloned and it will fail.
         */
        delete nextState.onEmbedded;
        this.setState(nextState);
    }

    validateConfig(config: IEmbedConfiguration) {
        const errors = models.validateReportLoad(config);
        return errors === undefined;
    }

    render() {
        const { className } = this.props;

        return (
            <div
                className={`powerbi-frame ${className}`}
                ref={ref => (this.rootElement = ref!)}
                style={{ height: "100%" }}
            ></div>
        );
    }
}

// Report.propTypes = {
//   accessToken: React.PropTypes.string,
//   embedUrl: React.PropTypes.string
// }

function assign(...args: any[]) {
    var target = args[0];

    if (target === undefined || target === null) {
        throw new TypeError("Cannot convert undefined or null to object");
    }

    var output = Object(target);
    for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index];
        if (source !== undefined && source !== null) {
            for (var nextKey in source) {
                if (source.hasOwnProperty(nextKey)) {
                    output[nextKey] = source[nextKey];
                }
            }
        }
    }
    return output;
}

export default PowerBiEmbeddedReport;
